export function SliderBerg_isset(arr, var_args) {
  for (var i = 1, k = arguments.length; i < k; ++i) {
    if (!arr || !arr.hasOwnProperty(arguments[i])) return false;
    arr = arr[arguments[i]];
  }
  return true;
}

export function SliderBerg_mapOrder(array, order, key) {
  array.sort(function(a, b) {
    var A = a[key],
      B = b[key];

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
  });

  return array;
}

export function SliderBerg_Color(number_of_color = 999) {
  let original_colors = [
    { name: 'WHITE', hex: '#ffffff' },
    { name: 'BLACK', hex: '#000' },
    { name: 'WISTERIA', hex: '#8e44ad' },
    { name: 'NEPHRITIS', hex: '#27ae60' },
    { name: 'SUN FLOWER', hex: '#f1c40f' },
    { name: 'CARROT', hex: '#e67e22' },
    { name: 'ALIZARIN', hex: '#e74c3c' },
    { name: 'CLOUDS', hex: '#ecf0f1' },
    { name: 'CONCRETE', hex: '#95a5a6' },
    { name: 'ORANGE', hex: '#f39c12' },
    { name: 'PUMPKIN', hex: '#d35400' },
    { name: 'POMEGRANATE', hex: '#c0392b' },
    { name: 'SILVER', hex: '#bdc3c7' },
    { name: 'ASBESTOS', hex: '#7f8c8d' },
    { name: 'TURQUOISE', hex: '#1abc9c' },
    { name: 'EMERALD', hex: '#2ecc71' },
    { name: 'PETER RIVER', hex: '#3498db' },
    { name: 'AMETHYST', hex: '#9b59b6' },
    { name: 'WET ASPHALT', hex: '#34495e' },
    { name: 'GREEN SEA', hex: '#16a085' },
    { name: 'BELIZE HOLE', hex: '#2980b9' },
    { name: 'MIDNIGHT BLUE', hex: '#2c3e50' }
  ];

  let return_colors = [];
  original_colors.forEach(color => {
    return_colors.push({
      name: color.name,
      color: color.hex,
      slug: color.name.toLowerCase()
    });
  });

  if (number_of_color < 999) {
    return return_colors.slice(0, number_of_color);
  }

  return return_colors;
}

export function SliderBerg_GoogleFontLoader(font) {
  let fetchStyle = function(url) {
    return new Promise((resolve, reject) => {
      let link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.onload = function() {
        resolve();
      };
      link.href = url;

      let headScript = document.querySelector('script');
      headScript.parentNode.insertBefore(link, headScript);
    });
  };

  if (font == 'Theme Default') return false;
  if (font == 'Arial') return false;

  if (!SliderBerg.google_fonts.includes(font)) {
    fetchStyle(`https://fonts.googleapis.com/css?family=` + font.replace(' ', '+'));
    SliderBerg.google_fonts.push(font);
  }
}



// WEBPACK FOOTER //
// ./src/js/utils.js